export default __webpack_public_path__ + "static/media/quote.b771d3b1.svg";